import { get } from 'lodash';

const defaultSettings = {
  conferencing: false,
  tableName: 'Case',
  currentId: '',
  priorId: '',
  browser: '',
  ignoreResize: false,
  displayMode: 'embedded', // other options 'popup' or 'fullscreen'
  displayDST: true,
  displayViewer: true,
  displayPinDropNav: true,
  displayLabels: true,
  lockMode: false, // true if user does not have edit access to the case, or the case tab is locked on the main tabs row
  iosMode: false, // true if running on ios device
  refreshRequired: false,
  usePAL: false,
  flashViewer: {
    flashVars: '',
    movieSrc: ''
  },
  dstInfo: {},
  vilSettings: {
    divId: ''
  },
  accordionSettings: {
    divId: 'accordionContainer',
    // TODO: Remove this everywhere - divHandlerId: 'accordionHandlerContainer',
    divImport: null,
    // TODO: Remove this everywhere - collapseTrayCallback: 'collapseTray',
    // TODO: Use this: collapsed: false,
    divImportDst: null
    // TODO: Use this or remove: displayHandlerTitle: true
  },
  dstSettings: {
    divId: 'dstContainer',
    dstTitle: 'eSlide Tray',
    caption: '',
    displayGroupings: true,
    displayGroupTitles: false,
    displayLabels: true,
    displayMemos: true,
    iconOrientation: 'right', // note - this must be either 'left' or 'right'
    displayBackgroundHighlight: false,
    displaySlideInfo: true,
    displayPosNegControl: false,
    displayMultiSlide: false,
    allowMemoEdit: true,
    displaySummaryTitle: true,
    enableEnhancedView: true,
    enableLabelPopup: false,
    enableReordering: true,
    enableMultiTray: true,
    enableToggleReadStatus: true,
    allowRemoveSlides: false,
    allowDeleteSlides: false,
    allowToggleRead: true,
    allowContextMenu: true,
    allowMultipleSelections: true,
    slidesPerTray: 20,
    slidesPerColumn: 10,
    traysPerMulti: 3,
    uniqueId: '',
    lockMode: false,
    iosMode: false,
    multiTrayWidth: 1300,
    multiTrayHeight: 525,
    loadPriors: true,
    height: 0,
    autoSelectSlide: true
  },
  uScope: {
    setup: {
      divId: 'uscope',
      userName: '',
      title: '',
      userid: '',
      createdBy: 'VIL'
    },
    toolbarOptions: {
      openImageScopeBtn: true,
      dscSetupBtn: true,
      resizeBtn: true,
      openPDNBtn: true,
      autoRaster: false,
      nextPrevSlide: false,
      printBtn: true,
      imageAdjustment: true
    },
    overlays: {
      label: false, // get from UserRights
      magnifier: true,
      thumbnail: true,
      scalebar: true,
      zoombar: true,
      rotation: true,
      heatmap: false,
      none: false
    },
    extensions: {
      'us:imagescope-launcher': {
        urlGenerator: 'nameOfGlobalFunction',
        targetUrlTemplate: '/BulkAction.php?Command=BulkImageScopeView&&ImageIds[]={IMAGE_IDS}&TableName=Image',
        filename: 'DigitalSlides.sis'
      }
    },
    features: {
      annotationsEnabled: true,
      dscEnabled: true,
      linkToImage: true,
      saveMacro: true,
      runAnalysis: true,
      snapshotMode: 'printViewport'
    },
    images: [
      // Do not remove this default images property of uScope (empty array) - it will be merged in if not present, and it's presence may be assumed by uScope
      // Furthermore, do not remove the commented out sample image below - it serves as a example for how to inject images via VIL constructor

      // { // up to four images
      //     imagePath: '',     // @123
      //     fullURL: '',       // aperio-00816/imageserver/@@CsZ9kj_25A2bkO8hd6hHmE8QrjFvdQszvEl3oCYzPIEEjpaWGu0KWQ==/@123
      //     x: '',
      //     y: '',
      //     z: '',             // Z-index
      //     mag: 'Fit',        // 'Fit', 'Scan' or '2', '4', '10', etc
      //     regionId: '',
      //     saveAnnotations: true  // user rights: if user has full access to the datagroup for the image
      // }
    ]
  },
  pindrop: {
    listObj: [], // some of these should be internal
    primarycaseId: '',
    displayCollapsed: false, // expose publically
    selectedIndex: 0,
    selectedRegionId: 0,
    maxPindrops: 5
  },
  DSC: {
    dscId: '',
    authToken: '',
    fullName: '',
    userId: '',
    confManagerDivId: '',
    vilDivId: ''
  },
  parentDiv: '',
  workFlowDiv: '',
  popupTitle: '',
  simulate: false
};

export function parseLegacyOptions (options) {
  const settings = {};

  $.extend(true, settings, defaultSettings);

  if (options) {
    $.extend(true, settings, options);
  }

  settings.initialLockMode = settings.lockMode;

  // Set browser
  if ((/MSIE (\d+\.\d+);/.test(navigator.userAgent)) || /Trident/.test(navigator.userAgent)) {
    settings.browser = 'IE';
  } else if (/Firefox[/\s](\d+\.\d+)/.test(navigator.userAgent)) {
    settings.browser = 'Firefox';
  } else if (/Chrome[/\s](\d+\.\d+.\d+\.\d+)/.test(navigator.userAgent)) {
    settings.browser = 'Chrome';
  }

  settings.dstSettings.iosMode = settings.iosMode;

  // if label visibility is prohibited, override dst and uScope's settings
  if (!settings.displayLabels) {
    settings.dstSettings.displayLabels = settings.displayLabels;
    settings.uScope.overlays.label = settings.displayLabels;
  }

  // Disable DST when loading Flash viewer
  if (settings.flashViewer.flashVars) {
    settings.displayDST = false;
  }

  return settings;
}

export function getTokenFromLegacyConfig (options) {
  let token = '';
  // "//host/imageserver/@@Sef1ElOKwwcgkVlIHNHKCvTPGj0HGG5-UyCvgGlJ8dPr8G5983KAvQ==/@558"
  const fullUrl = get(options, 'dstInfo.cases[0].slides[0].fullURL');
  if (fullUrl) {
    const bits = fullUrl.split('/');
    // pop off the image id
    bits.pop();
    token = bits.pop().substring(2);
  }
  return token;
}



// WEBPACK FOOTER //
// ./src/viewer/core/instance/config/legacy-support.js